import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
export var LinkedEntity = /*#__PURE__*/function (_ValueObject) {
  _inherits(LinkedEntity, _ValueObject);

  var _super = _createSuper(LinkedEntity);

  function LinkedEntity() {
    _classCallCheck(this, LinkedEntity);

    return _super.apply(this, arguments);
  }

  _createClass(LinkedEntity, [{
    key: "entityType",
    get: function get() {
      return this.props.entityType;
    }
  }, {
    key: "entityId",
    get: function get() {
      return this.props.entityId;
    }
  }, {
    key: "extra",
    get: function get() {
      return this.props.extra;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.entityType,
        argumentName: 'Entity type'
      }, {
        argument: props.entityId,
        argumentName: 'Entity id'
      }];
      var result = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!result.succeeded) {
        var _result$message;

        return Result.fail((_result$message = result.message) !== null && _result$message !== void 0 ? _result$message : 'Invalid linked entity');
      }

      return Result.ok(new LinkedEntity(props));
    }
  }]);

  return LinkedEntity;
}(ValueObject);